import { faArrowsToCircle, faHand, faMousePointer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";

import arrowIcon from "../../../assets/images/arrow.svg";
import storeIcon from "../../../assets/images/store.svg";
import terminalIcon from "../../../assets/images/terminal.svg";
import wallIcon from "../../../assets/images/wall.svg";
import zoneIcon from "../../../assets/images/Zone.svg";
import fileImportIcon from "../../../assets/images/fileImport.svg";
import ToolTip from "../../../shared/components/ToolTip/ToolTip";
import { Store } from "../../../store";
import { easeToValuesRAF } from "../drawUtils";
import "../index.css";
import "./index.css";
import ImportObjectsModal from "../../ObjectImportModal/ObjectImportModal";

const KEY_TO_TOOL_MAP = {
  r: "rack",
  w: "wall",
  z: "zone",
  a: "area",
  d: "dock",
  // i: "import",
};

const TOOL_CONTROLS = [
  { type: "selection", icon: faMousePointer, shortcut: null, title: "Select" },
  { type: "move", icon: faHand, shortcut: null, title: "Pan" },
  { type: "recenter", icon: faArrowsToCircle, shortcut: null, title: "Re-center" },
];

const OBJECT_CONTROLS = [
  { type: "rack", icon: storeIcon, shortcut: "R", title: "Rack" },
  { type: "wall", icon: wallIcon, shortcut: "W", title: "Wall" },
  { type: "area", icon: arrowIcon, shortcut: "A", title: "Area" },
  { type: "zone", icon: zoneIcon, shortcut: "Z", title: "Zone" },
  { type: "dock", icon: terminalIcon, shortcut: "D", title: "Dock" },
  // { type: "import", icon: fileImportIcon, shortcut: "I", title: "Import" },
];

const LayoutControls = ({ onSetTool = () => {}, currentTool = null }) => {
  const { state, dispatch } = useContext(Store);
  const [animations, setAnimations] = useState([]);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const handlePanReset = () => {
    const cancelAnimation = easeToValuesRAF({
      fromValues: state.layoutEditor.panOffset,
      toValues: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
      duration: 1000,
      onStep: (values) => {
        dispatch({
          type: "SET_PAN_OFFSET",
          payload: values,
        });
      },
    });
    setAnimations([...animations, { cancel: cancelAnimation }]);
  };

  useEffect(() => {
    handlePanReset();
    return () => {
      animations.forEach((animation) => {
        animation.cancel();
      });
    };
  }, []);

  // Keyboard Shortcuts for Tool Selection
  useEffect(() => {
    // Mapping of keyboard keys to their corresponding tool names

    const handleKeyDown = (e) => {
      // Skip if key is pressed in form elements
      // Also when the ctrl key is pressed
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLSelectElement ||
        e.target instanceof HTMLTextAreaElement ||
        e.target.isContentEditable ||
        e.ctrlKey
      ) {
        return;
      }

      const tool = KEY_TO_TOOL_MAP[e.key.toLowerCase()];

      // If a valid tool key was pressed, set the tool and prevent default key behavior
      if (tool) {
        onSetTool(tool);
        e.preventDefault();
        return;
      }
    };

    // Add the event listener to the window object
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup function: removes the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const showImportModal = () => {
    setIsImportModalOpen(true);
  };
  const handleImport = (data) => {
    setIsImportModalOpen(false);
  };

  const renderControl = ({ type, icon, shortcut, title }, isIconComponent) => {
    return (
      <ToolTip title={title} key={type}>
        <div
          className={`canvas-control ${currentTool === type ? "active" : ""}`}
          onClick={() => (type === "recenter" ? handlePanReset() : type === "import" ? showImportModal() : onSetTool(type))}
        >
          {isIconComponent ? <FontAwesomeIcon icon={icon} className="canvas-control-icon" /> : <img src={icon} className="layoutEditorIcon" />}
          {shortcut && (
            <div className="tool-shortcut">
              <span className="tool-shortcut-key">{shortcut}</span>
            </div>
          )}
          {/* <FontAwesomeIcon icon={icon} className="canvas-control-icon" /> */}
        </div>
      </ToolTip>
    );
  };

  return (
    <div className="layout-editor-canvas-controls">
      <div className="canvas-controls-section">{TOOL_CONTROLS.map((control) => renderControl(control, true))}</div>
      <div className="canvas-controls-divider"></div>
      <div className="canvas-controls-section">{OBJECT_CONTROLS.map((control) => renderControl(control, false))}</div>
      {isImportModalOpen && <ImportObjectsModal open={isImportModalOpen} onClose={() => setIsImportModalOpen(false)} onImport={handleImport} />}
    </div>
  );
};

export default LayoutControls;
